var _style, _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiesgocondenzacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97.89 97.89",
    style: {
      enableBackground: "new 0 0 97.89 97.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 652.47,
    y: 558.97,
    className: "st0",
    width: 24,
    height: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 366.47,
    y: 150.47,
    className: "st0",
    width: 97.89,
    height: 97.89
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.7,23.38c-1.23-2.3-2.47-4.55-3.81-6.77c-1.34,2.23-2.57,4.47-3.81,6.77c-2.26,4.11-5.11,9.02-5.38,13.85 c0.06,0.13,0.08,0.26,0.09,0.42c0.11,4.96,4.02,9.19,9.19,9.19c4.96,0,8.79-4.04,9.17-8.85c-0.04-0.11-0.08-0.21-0.08-0.34 C72.98,32.77,69.92,27.6,67.7,23.38z",
    fill: "#ED1C24",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.83,35.32c-2.26,3.75-4.34,7.62-6.32,11.51c-1.91,3.81-3.81,7.6-5.28,11.62c-1.26,3.17-2.43,6.55-2.53,9.92 c0.21,7.72,6.34,14.15,14.15,14.15c7.81,0,13.94-6.45,14.15-14.15v-0.02c-0.11-3.38-1.38-6.75-2.53-9.92 c-1.47-4.02-3.38-7.81-5.28-11.62C43.2,42.94,41.07,39.08,38.83,35.32z",
    fill: "#ED1C24",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.94,0C21.91,0,0,21.91,0,48.94c0,27.04,21.91,48.94,48.94,48.94c27.04,0,48.94-21.91,48.94-48.94 C97.89,21.91,75.98,0,48.94,0z M38.85,85.19c-9.3,0-16.59-7.6-16.79-16.79c0.11-7.51,4.34-15.21,7.6-21.77 c2.53-4.96,5.17-9.83,8.04-14.59c0.53-0.85,1.79-0.85,2.32,0c2.85,4.75,5.6,9.62,8.04,14.59c3.28,6.55,7.51,14.26,7.6,21.77 C55.45,77.47,48.15,85.19,38.85,85.19z M75.83,37.64c0,0.11,0,0.23-0.02,0.34c-0.38,6.3-5.28,11.49-11.81,11.49 c-6.34,0-11.3-5.06-11.79-11.23c-0.09-0.17-0.13-0.38-0.13-0.6c0.11-5.08,2.85-10.15,5.17-14.59c1.79-3.28,3.58-6.55,5.6-9.72 c0.64-0.85,1.79-0.85,2.32,0c2,3.17,3.81,6.34,5.49,9.72c2.28,4.36,4.96,9.32,5.17,14.3C75.83,37.43,75.85,37.53,75.83,37.64z",
    fill: "#ED1C24",
    fillOpacity: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiesgocondenzacion);
export default __webpack_public_path__ + "static/media/riesgo condenzacion.ace300ef64ce87fb0ef75b5bd72db538.svg";
export { ForwardRef as ReactComponent };